const PurchaseIframe: React.FC<{ children?: React.ReactNode; src: string; title: string }> = ({
  children,
  src,
  title,
}) => (
  <div className="tw-relative tw-w-full tw-h-full">
    <div id="purchase-backdrop" />
    <iframe id="purchase-iframe" src={src} title={title} className="tw-w-full tw-h-full tw-border-none" />
    {children}
  </div>
);

export default PurchaseIframe;
